export default {
    sending: false,
    showActiveConversation: true,
    intelligentFilterEnabled: localStorage.getItem('intelligentFilterEnabled')
        ? JSON.parse(localStorage.getItem('intelligentFilterEnabled'))
        : true,
    conversations: [],
    conversationsPage: 1,
    conversationsTotal: 0,
    conversationsFetchId: +new Date(),
    selectedConversationId: null,
    selectedTemplate: {},
    templates: [],
    selectedTemplateCategory: {},
    templateCategories: [],
    selectedContactId: null,
    contactRelatedId: null,
    userRelatedId: null,
    selectedUserId: null,
};
